import React, { useEffect } from 'react';
import Header from '../Header';
import Footer from '../Global/Footer/Footer';

import '../../styles/main.scss';

const Layout = ({ children, hideLinks = false, hideFooter = false, homepage = false }) => {
  useEffect(() => {
    // Plausible  tracking code
    const plausibleScript = document.createElement('script');
    plausibleScript.defer = true;
    plausibleScript.setAttribute('data-domain', 'europeangreens.eu');
    plausibleScript.src = 'https://plausible.io/js/script.js';
    document.body.appendChild(plausibleScript);
    // console.log('Plausible created: ', plausibleScript.src);

    // Tito
    const titoCode = document.createElement('script');
    titoCode.src = 'https://js.tito.io/v2/with/inline/without/widget-css';
    document.body.appendChild(titoCode);

    // Hubspot
    const hubspotBanner = document.createElement('script');
    hubspotBanner.src =
      'https://js-eu1.hs-banner.com/cookie-scanning/26289884/ddefb207014995f2b33c73d451082bc760ad2086d41459688d4a1e5dc4ae2dbd.js';
    hubspotBanner.id = 'hs-cookie-banner-scan';
    hubspotBanner.type = 'application/javascript';
    hubspotBanner.setAttribute('data-hs-allowed', 'true');
    document.body.appendChild(hubspotBanner);
    // console.log('Hubspot banner created: ', hubspotBanner.id);

    // Hubspot tracking code
    const trackingHubspot = document.createElement('script');
    trackingHubspot.id = 'hs-script-loader';
    trackingHubspot.src = 'https://js-eu1.hs-scripts.com/26289884.js';
    document.body.appendChild(trackingHubspot);
  });

  return (
    <>
      <a href="#main-content" className="visually-hidden-focusable">
        Skip to content
      </a>

      <div style={{ position: 'relative' }}>
        <Header hideLinks={hideLinks} homepage={homepage} />
        <main>{children}</main>
        {!hideFooter && <Footer />}
      </div>
    </>
  );
};

export default Layout;
